import wx from 'weixin-js-sdk';
import Axios from "axios";
import qs from 'qs'

const ShareImpl = function (option) {

    const url = location.href.split("#")[0];
    Axios.post('https://node.epailive.com/rsx', qs.stringify({url:url})).then((response) => {
        wx.config({
            debug: false,
            appId: response.data.appid,
            timestamp: parseInt(response.data.timestamp),
            nonceStr:  response.data.nonceStr,
            signature: response.data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage',]
        });
    }).catch(error => {
        window.console.log(error);

    });

    wx.ready(function () {
        console.log(option,'ssssssss')
        wx.onMenuShareTimeline({
            title: option.shareTitle,

            desc: option.shareDesc,

            link: option.shareUrl,

            imgUrl: option.shareImg

        });

        wx.onMenuShareAppMessage({
            title: option.shareTitle,

            desc: option.shareDesc,

            link: option.shareUrl,

            imgUrl: option.shareImg,

        });

    })/*}*/
}

export default ShareImpl